var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "product-box product-box--searched product-box--featured v-product-item"
    },
    [
      _c("div", { staticClass: "product-box__images" }, [
        _c("a", { attrs: { href: "/products/" + _vm.handle } }, [
          _c("div", { staticClass: "product-image" }, [
            _c("img", { attrs: { alt: "main-image", src: _vm.mainImage } }),
            _vm._v(" "),
            _vm.hoverImage
              ? _c("img", {
                  staticClass: "image--hover",
                  attrs: {
                    id: "ProductCardImage-header-1883398963251-1",
                    alt: "GIF-hover",
                    src: _vm.hoverImage
                  }
                })
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "product-box--top-searched-box" }, [
        _c(
          "div",
          {
            staticClass:
              "product-box__title product-box--white-background product-box--fix-height product-box__top-searched"
          },
          [
            _c("a", { attrs: { href: "/products/" + _vm.handle } }, [
              _vm._v("\n        " + _vm._s(_vm.title) + "\n      ")
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "product-box--regular-product" }, [
          _c("div", { staticClass: "price-box" }, [
            _vm.priceCompare.length > 0
              ? _c("div", { staticClass: "price-box__sale" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.originalPrice) + "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.priceCompare.length > 0
              ? _c("div", { staticClass: "price-box__compare" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.compareAtPrice) + "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.priceCompare.length == 0
              ? _c("div", { staticClass: "price-box__regular" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.originalPrice) + "\n        "
                  )
                ])
              : _vm._e()
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }